module.exports = __webpack_public_path__ + "img/ksteel_logo_white.4d48e46f.png";